import { render, staticRenderFns } from "./MechanicForm.vue?vue&type=template&id=d05f82fe"
import script from "./MechanicForm.vue?vue&type=script&lang=js"
export * from "./MechanicForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports